import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslatePipe} from '@ngx-translate/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription, combineLatest} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ViewService} from '../../api/services/view.service';
import {ToursService} from '../../api/services/tour.service';
import {SavedView} from '../../api/interfaces/saved-view';

@Component({
  selector: 'maporium-scene-panel',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, TranslatePipe],
  styleUrls: ['scene-panel.component.scss'],
  template: `
    <div class="scene-panel" *ngIf="scene && scene.showDescription !== false">
      <div class="scene-header">
        <button class="reset-btn"
                type="button"
                (click)="reset()"
                [matTooltip]="'SCENES_V1.PANEL.TOOLTIP_RESET' | translate"
                matTooltipPosition="above">
          <span class="material-symbols-rounded">loop</span>
        </button>
        <span class="scene-title">{{ scene.name }}</span>
        <button class="close-btn"
                type="button"
                (click)="close()"
                [matTooltip]="'SCENES_V1.PANEL.TOOLTIP_CLOSE' | translate"
                matTooltipPosition="above">
          <span class="material-symbols-rounded">close</span>
        </button>
      </div>
      <div class="scene-content" *ngIf="scene.description">
        {{ scene.description }}
      </div>
    </div>
  `
})
export class ScenePanelComponent implements OnInit, OnDestroy {
  scene: SavedView | null = null;
  private subscriptions: Subscription[] = [];

  constructor(
    private viewService: ViewService,
    private toursService: ToursService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Show the panel only when a standalone scene is active AND no story is
    // running — when a story owns playback, the story panel takes over per AC.
    this.subscriptions.push(
      combineLatest([
        this.viewService.activeScene$,
        this.toursService.activateTourSubject
      ]).subscribe(([scene, tour]) => {
        this.scene = tour ? null : scene;
        this.cdr.markForCheck();
      })
    );

    // Clear the active scene on map navigation so a stale scene from the
    // previous smap doesn't linger over a different one.
    this.subscriptions.push(
      this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
        this.viewService.activeScene$.next(null);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  reset(): void {
    if (!this.scene) return;
    // playView pushes the scene back through activeScene$, which keeps the
    // panel open with the same content (updates in place rather than reopens).
    this.viewService.playView(this.scene);
  }

  close(): void {
    this.viewService.activeScene$.next(null);
  }
}
